export const messages = {
  en: {
    floorShare: {
      title: 'Floor Share',
      id: 'ID',
      floor: 'Floor',
      meterType: 'Meter Type',
      meterNum: 'Meter Number',
      shareType: 'Share Type',
      formula: 'Formula',
      feeItem: 'Fee Item',
      feePrice: 'Fee Price',
      degree: 'Degree',
      readingTime: 'Reading Time',
      createTime: 'Create Time',
      addTitle: 'Add Floor Share',
      editTitle: 'Edit Floor Share',
      deleteConfirm: 'Confirm Operation',
      deleteMessage: 'Are you sure to delete this floor share?',
      fetchError: 'Failed to fetch floor share data',
      fetchFloorError: 'Failed to fetch floor data',
      fetchFeeConfigError: 'Failed to fetch fee config data',
      addSuccess: 'Floor share added successfully',
      addFailed: 'Failed to add floor share',
      editSuccess: 'Floor share updated successfully',
      editFailed: 'Failed to update floor share',
      deleteSuccess: 'Floor share deleted successfully',
      deleteFailed: 'Failed to delete floor share',
      meterTypeRequired: 'Please select meter type',
      feeItemRequired: 'Please select fee item',
      feePriceRequired: 'Please enter fee price',
      feePriceNumber: 'Fee price must be a number',
      shareTypeRequired: 'Please select share type',
      formulaRequired: 'Please enter formula',
      idRequired: 'ID is required',
      meterNumPlaceholder: 'Optional, please enter meter number',
      meterNumTip: 'Enter 1 if no meter number',
      electricMeter: 'Electric Meter',
      waterMeter: 'Water Meter',
      byArea: 'By Area',
      byHouse: 'By House',
      byFormula: 'By Formula'
    }
  },
  zh: {
    floorShare: {
      title: '楼栋公摊',
      id: '编号',
      floor: '楼栋',
      meterType: '表类型',
      meterNum: '表编号',
      shareType: '公摊方式',
      formula: '公式',
      feeItem: '费用项',
      feePrice: '费用单价',
      degree: '度数',
      readingTime: '抄表时间',
      createTime: '创建时间',
      addTitle: '添加楼栋公摊',
      editTitle: '修改楼栋公摊',
      deleteConfirm: '请确认您的操作',
      deleteMessage: '确定删除楼栋公摊吗？',
      fetchError: '获取楼栋公摊数据失败',
      fetchFloorError: '获取楼栋数据失败',
      fetchFeeConfigError: '获取费用项数据失败',
      addSuccess: '楼栋公摊添加成功',
      addFailed: '楼栋公摊添加失败',
      editSuccess: '楼栋公摊修改成功',
      editFailed: '楼栋公摊修改失败',
      deleteSuccess: '楼栋公摊删除成功',
      deleteFailed: '楼栋公摊删除失败',
      meterTypeRequired: '请选择表类型',
      feeItemRequired: '请选择费用项',
      feePriceRequired: '请输入费用单价',
      feePriceNumber: '费用单价必须为数字',
      shareTypeRequired: '请选择公摊方式',
      formulaRequired: '请输入公式',
      idRequired: '编号不能为空',
      meterNumPlaceholder: '选填，请填写表编号',
      meterNumTip: '没有表号请填写1',
      electricMeter: '电表',
      waterMeter: '水表',
      byArea: '按面积',
      byHouse: '按户',
      byFormula: '按公式'
}
  },
  'zh-TW': {
    floorShare: {
      title: '樓棟公攤',
      id: '編號',
      floor: '樓棟',
      meterType: '表類型',
      meterNum: '表編號',
      shareType: '公攤方式',
      formula: '公式',
      feeItem: '費用項',
      feePrice: '費用單價',
      degree: '度數',
      readingTime: '抄表時間',
      createTime: '創建時間',
      addTitle: '添加樓棟公攤',
      editTitle: '修改樓棟公攤',
      deleteConfirm: '請確認您的操作',
      deleteMessage: '確定刪除樓棟公攤嗎？',
      fetchError: '獲取樓棟公攤數據失敗',
      fetchFloorError: '獲取樓棟數據失敗',
      fetchFeeConfigError: '獲取費用項數據失敗',
      addSuccess: '樓棟公攤添加成功',
      addFailed: '樓棟公攤添加失敗',
      editSuccess: '樓棟公攤修改成功',
      editFailed: '樓棟公攤修改失敗',
      deleteSuccess: '樓棟公攤刪除成功',
      deleteFailed: '樓棟公攤刪除失敗',
      meterTypeRequired: '請選擇表類型',
      feeItemRequired: '請選擇費用項',
      feePriceRequired: '請輸入費用單價',
      feePriceNumber: '費用單價必須為數字',
      shareTypeRequired: '請選擇公攤方式',
      formulaRequired: '請輸入公式',
      idRequired: '編號不能為空',
      meterNumPlaceholder: '選填，請填寫表編號',
      meterNumTip: '沒有表號請填寫1',
      electricMeter: '電表',
      waterMeter: '水錶',
      byArea: '按面積',
      byHouse: '按戶',
      byFormula: '按公式'
    }
  }
}